module.exports = __webpack_public_path__ + "static/img/list_fr.c5a600c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/list_fr.svg
// module id = erYr
// module chunks = 0